import {graphConfig, users} from "auth/authAzure";

/**
 * Attaches a given access token to a MS Graph API call. Returns information about the user
 * @param accessToken
 */
export async function callMsGraph(accessToken) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    return fetch(graphConfig.graphMeEndpoint, options)
        .then(response => response.json())
        .catch(error => console.log(error));
}

export async function getUsers(accessToken) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    return fetch(users.graphMeEndpoint, options)
        .then(response => response.json())
        .catch(error => error);
}
export async function getGroups(accessToken) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    ///b8aacba9-42d4-4333-a6c5-ca817e68430c   96173136-36e1-4891-9244-265cc8c2fb84
    return fetch(`https://graph.microsoft.com/v1.0/groups/96173136-36e1-4891-9244-265cc8c2fb84/members`, options)
        .then(response => response.json())
        .catch(error => error);
}

export async function addMemberGroup(accessToken, id) {

    const headers = new Headers({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`,
    });


    const directoryObject = JSON.stringify({
        '@odata.id': 'https://graph.microsoft.com/v1.0/directoryObjects/' + id
    });

    const options = {
        method: "POST",
        headers: headers,
        body: directoryObject
    };
    ///96173136-36e1-4891-9244-265cc8c2fb84
    return fetch(`https://graph.microsoft.com/v1.0/groups/96173136-36e1-4891-9244-265cc8c2fb84/members/$ref`, options)
        .then(response => console.log('response add user group', response))
        .catch(error => error);
}



export async function getUsersId(accessToken, id) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "GET",
        headers: headers
    };

    return fetch(`${users.graphMeEndpoint+id}?$select=displayName, accountEnabled`, options)
        .then(response => response.json())
        .catch(error => error);
}

export async function setUsers(accessToken, data) {
    const headers = new Headers({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`,
    });

    const options = {
        method: "POST",
        headers: headers,
        body: data,
    };

    const request = new Request(users.graphMeEndpoint, options);

    return fetch(request)
        .then(response => response.json())
        .catch(error => console.log(error.response));
}

export async function deleteUser(accessToken, id) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    const options = {
        method: "DELETE",
        headers: headers
    };

    return fetch(users.graphMeEndpoint+id, options)
        .then(response => {
            if (response.ok) {
                return true
            }
        })
        .catch(error => error);
}

export async function editUser(accessToken, id, data) {
    const headers = new Headers({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`,
    });

    const options = {
        method: "PATCH",
        headers: headers,
        body: data,
    };

    const request = new Request(users.graphMeEndpoint+id, options);

    return fetch(request)
        .then(response => response)
        .catch(error => error);
}

export async function setPermissionAzure(accessToken, id) {
    const headers = new Headers({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`,
    });
  //  const admin  = "8f6db4eb-32fc-4a6d-afa8-e13260e234d7"
     const atendimento  = "ff28997e-0a10-4434-b60d-697ae5b88cb0"

    const data = {
        "principalId": id,
        "resourceId": "ed4de202-6fce-4978-a3e1-40b068a6506b",
        "appRoleId": atendimento
    }

    const options = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(data)
    };

    const request = new Request(`https://graph.microsoft.com/v1.0/users/${id}/appRoleAssignments`, options);

    return fetch(request)
        .then(response => response.json())
        .catch(error => error);
}
